import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconShieldCheckOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24"><path fill="currentColor" d="m10.67 16.055-4.383-4.383 1.06-1.06 3.323 3.323 5.98-5.983 1.06 1.06-7.043 7.043zM12 1.748 3.99 4.325v10.287c0 2.873 4.7 6.28 8.01 7.623 3.31-1.343 8.01-4.75 8.01-7.623V4.325zm0-1.746 9.667 3.13v11.476c0 4.174-6.167 8.174-9.667 9.39-3.5-1.216-9.666-5.216-9.666-9.39V3.135L12 .005z" /></svg>
);
